import React from 'react'

function WsetSide() {
  return (
    <div>
        {/* <Navbar/> */}
    </div>
  )
}

export default WsetSide